import { createSlice } from '@reduxjs/toolkit';
import {
  allSuggestionsThunk,
  allAutocompleteThunk,
  combinedSearchThunk,
} from './thunks';

const enhancedSearchSlice = createSlice({
  name: 'enhancedSearch',
  initialState: {
    suggestions: {
      isLoading: false,
      searchText: '',
      suggestions: [],
      isOffline: false,
    },
    autoComplete: {
      isLoading: false,
      searchText: '',
      queryPlusText: '',
    },
    combinedSearch: {
      isLoading: false,
      searchText: '',
      topicResults: {},
      drugResults: [],
      isOffline: false,
    },
  },
  reducers: {
    clearEnhancedSearchAutoComplete: (state) => {
      state.autoComplete = {
        ...state.autoComplete,
        queryPlusText: '',
      };
    },
    clearSuggestions: (state) => {
      state.suggestions = {
        isLoading: false,
        searchText: '',
        suggestions: [],
        isOffline: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(allSuggestionsThunk.pending, (state, action) => {
        state.suggestions = {
          ...state.suggestions,
          isLoading: true,
          searchText: action.meta.arg.searchText,
        };
      })
      .addCase(allSuggestionsThunk.fulfilled, (state, action) => {
        state.suggestions = {
          ...state.suggestions,
          suggestions: action.payload.suggestions,
          isOffline: action.payload.isOffline,
          isLoading: false,
        };
      })
      .addCase(allSuggestionsThunk.rejected, (state, action) => {
        state.suggestions = {
          ...state.suggestions,
          isOffline: true,
          isLoading: false,
        };
      })
      .addCase(allAutocompleteThunk.pending, (state, action) => {
        state.autoComplete = {
          ...state.autoComplete,
          isLoading: true,
          queryPlusText: '',
          searchText: action.meta.arg.searchText,
        };
      })
      .addCase(allAutocompleteThunk.fulfilled, (state, action) => {
        state.autoComplete = {
          ...state.autoComplete,
          queryPlusText: action.payload.queryPlusText,
          isLoading: false,
        };
      })
      .addCase(allAutocompleteThunk.rejected, (state, action) => {
        state.autoComplete = {
          ...state.autoComplete,
          queryPlusText: '',
          isLoading: false,
        };
      })
      .addCase(combinedSearchThunk.pending, (state, action) => {
        state.combinedSearch = {
          ...state.combinedSearch,
          searchText: action.meta.arg.searchText,
          isLoading: true,
        };
      })
      .addCase(combinedSearchThunk.fulfilled, (state, action) => {
        state.combinedSearch = {
          ...state.combinedSearch,
          requestArgs: action.meta.arg,
          topicResults: action.payload.topicResults,
          drugResults: action.payload.drugResults,
          isOffline: action.payload.isOffline,
          isLoading: false,
        };
      })
      .addCase(combinedSearchThunk.rejected, (state, action) => {
        state.combinedSearch = {
          ...state.combinedSearch,
          isOffline: true,
          isLoading: false,
        };
      });
  },
});

export default enhancedSearchSlice.reducer;

export const { clearEnhancedSearchAutoComplete } = enhancedSearchSlice.actions;

export const selectSuggestions = (state) =>
  state.enhancedSearchSlice.suggestions.suggestions;
export const selectAutoCompleteTextPlus = (state) =>
  state.enhancedSearchSlice.autoComplete.queryPlusText;
export const selectTopicResults = (state) =>
  state.enhancedSearchSlice.combinedSearch.topicResults;
export const selectTopicQuery = (state) =>
  state.enhancedSearchSlice.combinedSearch?.requestArgs;
export const selectDrugResults = (state) =>
  state.enhancedSearchSlice.combinedSearch.drugResults;
export const loadingCombinedSearch = (state) =>
  state.enhancedSearchSlice.combinedSearch.isLoading;
export const selectSearchAutoCompleteQueryPlusText = (state) =>
  state.enhancedSearchSlice.autoComplete.queryPlusText;

export const { clearSuggestions } = enhancedSearchSlice.actions;